"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _console = require("@instructure/console");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));
var _debounce = _interopRequireDefault(require("@instructure/debounce"));
var _addResizeListener = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/addResizeListener"));
var _canUseDOM = _interopRequireDefault(require("@instructure/ui-utils/lib/dom/canUseDOM"));
var _safeCloneElement = _interopRequireDefault(require("@instructure/ui-utils/lib/react/safeCloneElement"));
var _ensureSingleChild = _interopRequireDefault(require("@instructure/ui-utils/lib/react/ensureSingleChild"));
var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));
var _Truncator = require("./utils/Truncator");
var _theme = _interopRequireDefault(require("./theme"));
var _dec, _dec2, _class, _class2, _temp;
var styles = {
  componentId: 'bjXfh',
  template: function template(theme) {
    return "\n\n.bjXfh_daKB{display:block;font-family:".concat(theme.fontFamily || 'inherit', ";overflow:hidden;word-wrap:break-word}\n\n.bjXfh_uUeq{height:100%}\n\n.bjXfh_exvv{display:block;max-height:0;visibility:hidden}");
  },
  'truncated': 'bjXfh_daKB',
  'auto': 'bjXfh_uUeq',
  'spacer': 'bjXfh_exvv'
};

/**
---
category: components
---
**/
var TruncateText = (_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TruncateText, _Component);
  function TruncateText(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TruncateText);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TruncateText).call(this, props));
    _this.update = function () {
      if (_this._ref) {
        _this.setState(_this.initialState);
      }
    };
    _this.state = _this.initialState;
    return _this;
  }
  (0, _createClass2.default)(TruncateText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var children = this.props.children;
      if (children) {
        this.checkChildren();
        this._text = (0, _ensureSingleChild.default)(children);
        this.truncate();
        if (this.props.debounce === 0) {
          this._resizeListener = (0, _addResizeListener.default)(this._ref, this.update);
        } else {
          this._debounced = (0, _debounce.default)(this.update, this.props.debounce, {
            leading: true,
            trailing: true
          });
          this._resizeListener = (0, _addResizeListener.default)(this._ref, this._debounced);
        }
      }
    }
  }, {
    key: "componentWillUnMount",
    value: function componentWillUnMount() {
      if (this._resizeListener) {
        this._resizeListener.remove();
      }
      if (this._debounced) {
        this._debounced.cancel();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props !== nextProps) {
        this.setState(this.initialState);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
        children = _this$props.children,
        onUpdate = _this$props.onUpdate;
      var _this$state = this.state,
        isTruncated = _this$state.isTruncated,
        needsSecondRender = _this$state.needsSecondRender,
        truncatedText = _this$state.truncatedText;
      if (children) {
        if (prevProps !== this.props) {
          this.checkChildren();
          this._text = (0, _ensureSingleChild.default)(children);
        }
        if (!needsSecondRender && (isTruncated || this._prevTruncatedState)) {
          onUpdate(isTruncated, truncatedText);
          this._prevTruncatedState = isTruncated;
        } else {
          this.truncate();
        }
      }
    }
  }, {
    key: "checkChildren",
    value: function checkChildren() {
      var _this2 = this;

      /*#__PURE__*/
      (/*#__PURE__*/
      0, _console.error)(! /*#__PURE__*/
      function () {
        var isTooDeep = false;
        var text = (0, _ensureSingleChild.default)(_this2.props.children);
        _react.default.Children.forEach(text.props.children, /*#__PURE__*/
        function (child) {
          if (child.props) {
            _react.default.Children.forEach(child.props.children, /*#__PURE__*/
            function (grandChild) {
              // currently we don't support node trees deeper than 2 levels
              // truncation will still occur on their text content, but their actual node structure will be lost
              if (grandChild.props) {
                isTooDeep = true;
              }
            });
          }
        });
        return isTooDeep;
      }(), "[TruncateText] Some children are too deep in the node tree and will not render.");
    }
  }, {
    key: "truncate",
    value: function truncate() {
      if (!this.state.needsSecondRender) {
        return;
      }
      if (_canUseDOM.default) {
        var result = (0, _Truncator.truncate)(this._stage, (0, _objectSpread2.default)({}, this.props, {
          parent: this._ref,
          lineHeight: this.theme.lineHeight
        }));
        if (result) {
          var element = this.renderChildren(result.isTruncated, result.data, result.constraints.width);
          this.setState({
            needsSecondRender: false,
            isTruncated: result.isTruncated,
            truncatedElement: element,
            truncatedText: result.text
          });
        }
      } else {
        // if dom isn't available, use original children
        this.setState({
          needsSecondRender: false,
          isTruncated: false,
          truncatedElement: this._text,
          truncatedText: this._ref.textContent
        });
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(truncated, data, width) {
      if (!truncated) {
        return this._text;
      }
      var childElements = []; // iterate over each node used in the truncated string

      for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var element = this._text.props.children[i];
        var nodeText = item.join('');
        if (element && element.props) {
          // if node is an html element and not just a string
          childElements.push((0, _safeCloneElement.default)(element, element.props, nodeText));
        } else {
          childElements.push(nodeText);
        }
      } // this spacer element is set to the max width the full text could potentially be
      // without this, text in `width: auto` elements won't expand to accomodate more text, once truncated

      childElements.push(_react.default.createElement("span", {
        className: styles.spacer,
        style: {
          width: width || null
        }
      }));
      var children = _react.default.Children.map(childElements, function (child) {
        return child;
      });
      return this._text.props ? (0, _safeCloneElement.default)(this._text, this._text.props, children) : children;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
        _this3 = this;
      var truncatedElement = this.state.truncatedElement;
      var _this$props2 = this.props,
        maxLines = _this$props2.maxLines,
        children = _this$props2.children;
      return _react.default.createElement("span", {
        className: (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, styles.truncated, true), (0, _defineProperty2.default)(_classNames, styles.auto, maxLines === 'auto'), _classNames)),
        ref: function ref(el) {
          _this3._ref = el;
        }
      }, children && (truncatedElement ? null : _react.default.createElement("span", {
        ref: function ref(el) {
          _this3._stage = el;
        }
      }, (0, _ensureSingleChild.default)(children))), truncatedElement);
    }
  }, {
    key: "initialState",
    get: function get() {
      return {
        isTruncated: false,
        needsSecondRender: true,
        truncatedElement: null,
        truncatedText: null
      };
    }
  }]);
  TruncateText.displayName = "TruncateText";
  return TruncateText;
}(_react.Component), _class2.propTypes = {
  /**
  * The content to be truncated.
  */
  children: _propTypes.default.node.isRequired,
  /**
  * Number of lines to allow before truncating. `auto` will fit to parent
  */
  maxLines: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /**
  * Where to place the ellipsis within the string
  */
  position: _propTypes.default.oneOf(['end', 'middle']),
  /**
  * Add ellipsis after words or after any character
  */
  truncate: _propTypes.default.oneOf(['character', 'word']),
  /**
  * A string to use as the ellipsis
  */
  ellipsis: _propTypes.default.string,
  /**
  * Characters to ignore at truncated end of string
  */
  ignore: _propTypes.default.arrayOf(_propTypes.default.string),
  /**
  * Debounce delay in milliseconds
  */
  debounce: _propTypes.default.number,
  /**
  * Callback when truncated text has changed
  */
  onUpdate: _propTypes.default.func
}, _class2.defaultProps = {
  maxLines: 1,
  ellipsis: "\u2026",
  truncate: 'character',
  position: 'end',
  ignore: [' ', '.', ','],
  debounce: 0,
  onUpdate: function onUpdate(truncated, text) {}
}, _temp)) || _class) || _class);
var _default = TruncateText;
exports.default = _default;